import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=2f67fd9a&scoped=true"
import script from "./CarInfo.vue?vue&type=script&lang=js"
export * from "./CarInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67fd9a",
  null
  
)

export default component.exports